import React, { Component } from 'react'
import { connect } from 'react-redux'

import '../../assets/css/tor-template-list.css'
import { DatePicker,Select,InputDecimal,DropDownMuti,Input } from '../../components/core';
import $ from 'jquery'
import { SecureGateRoute, BreadCrumb, DetailBotLogModal } from '../../components';
import { searchReportOutstandingAction,exportReportOutstandingAction } from '../../redux/actions/SearchAction'
import SearchTablePage from '../../components/ReportOutstandingScreen/SearchTablePage';
import {AppSettings } from '../../configs'
import { Storage } from "../../configs";
import {
    data_status,
} from '../../configs/datas'
import moment from 'moment'
import {msg} from '../../components/Notifications/MsgBox';
import ReactTooltip from 'react-tooltip'
import {
    getAllUnitReviewerAction,
} from "../../redux/actions/DepartmentMapAction";


class ReportOutstandingScreen extends Component {
    constructor(props) {
        super(props)

        this.state = {
            serachConditionModel: {
                RRS_DOC_NO: '',
                PO_CONTRACT_NO: '',
                REQUISITIONER: '',
                UNIT: '',
                MOM_DOC_NO:'',
                CREATE_DATE_FROM:moment(new Date(new Date().getFullYear(), new Date().getMonth()-3, new Date().getDay()+1,0,0)).format('DD/MM/YYYY') ,
                CREATE_DATE_TO:moment(new Date()).format('DD/MM/YYYY') ,
                ROLE_ID: Storage.getRole(),
                USER: Storage.getUser().isAdmin == true ? '' : Storage.getUser().userName,
                IS_LOAD: false,
                IS_ADMIN: Storage.getUser().isAdmin,
            },
            isAdmin:Storage.getUser().isAdmin
        }

        //create date
        this.create_date_from_ref = React.createRef();
        this.create_date_to_ref = React.createRef();
        //Edit Date 
        this.edit_date_from_ref = React.createRef();
        this.edit_date_to_ref = React.createRef();

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDropdownMutiChange = this.handleDropdownMutiChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.statusOptions = this.statusOptions.bind(this);
        
    }

    async componentDidMount() {
        this.props.getAllUnitReviewer()
        let { serachConditionModel } = this.state;
        await this.props.searchReport(serachConditionModel);

        $(function () {
            window.onComponentDidMount()
        })
    }

    handleInputChange(event) {
        let { serachConditionModel } = this.state;
        const target = event.target
        let value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY')
                    }
                }
            }
        }

        serachConditionModel[name] = value;

        this.setState({
            serachConditionModel: serachConditionModel
        })
    }

    handleDropdownMutiChange(event) {
        let { serachConditionModel } = this.state;
        let value=null
        if(event)
        {
            const target = event.target
            value = event
        }

        serachConditionModel['UNIT'] = value

        console.log("handleDropdownMutiChange")
        console.log(serachConditionModel)
        this.setState({
            serachConditionModel: serachConditionModel
        })
    }

    async handleSearch(event) {
        let { serachConditionModel, isAdmin } = this.state;
        serachConditionModel.IS_LOAD=true;
        serachConditionModel.STATUS = null;
        let list_status=[];
        if(this.state.serachConditionModel.UNIT)
        {
            this.state.serachConditionModel.UNIT.map((item, key) =>
                list_status.push(item.value)
            );
        }
        serachConditionModel.UNITS = list_status.toString();

        event.preventDefault();
        await this.props.searchReport(serachConditionModel);
        if(this.props.resultReportOutSearch && this.props.resultReportOutSearch.length === 0)
        {
            msg.error("ไม่พบข้อมูล")
        }
        //await this.props.exportReport(serachConditionModel);
        
    }

    async handleExport(event) {
        let { serachConditionModel } = this.state;
        serachConditionModel.IS_LOAD=true;
        let list_status=[];
        if(this.state.serachConditionModel.UNIT)
        {
            this.state.serachConditionModel.UNIT.map((item, key) =>
                list_status.push(item.value)
            );
        }
        serachConditionModel.STATUS = list_status.toString();
        event.preventDefault();
         await this.props.exportReport(serachConditionModel);
         if (this.props.resultExport.isSuccess == true)
         {
            window.open( this.props.resultExport.returnMessage, '_blank', '');
         }
         else 
         {
            msg.error("ไม่พบข้อมูล");
         }
    }

    statusOptions = () => {

        let _unitreviewerAll=this.props.unitreviewerAll.map((data, index) => {
            let rObj = {}
            rObj["value"] = data.unit_Code
            rObj["label"] = data.unit_Code +":"+data.unit_Description
            console.log(rObj)
            return rObj
        })

        return Promise.resolve(_unitreviewerAll);
    }
    
    async handleClear(event) {

        event.preventDefault()
        await this.setState({
            serachConditionModel: {
                RRS_DOC_NO: '',
                MOM_DOC_NO: '',
                PO_CONTRACT_NO: '',
                UNIT: '',
                REQUISITIONER: '',
                CREATE_DATE_FROM: moment(new Date(new Date().getFullYear(), new Date().getMonth()-3, new Date().getDay()+1,0,0)).format('DD/MM/YYYY') ,
                CREATE_DATE_TO: moment(new Date()).format('DD/MM/YYYY') ,
                ROLE_ID: Storage.getRole(),
                USER: Storage.getUser().isAdmin == true ? '' : Storage.getUser().userName,
                IS_LOAD: false,
                IS_ADMIN: Storage.getUser().isAdmin,
            }
        })

        
        //create date
        this.create_date_from_ref.current.value = ''
        this.create_date_to_ref.current.value = ''
        
        window.$('#'+this.create_date_from_ref.current.props.id)
        // .datepicker({
        //     endDate: '+0d',
        //     todayHighlight: true,
        // })
        .datepicker(
            'setDate', moment(new Date(new Date().getFullYear(), new Date().getMonth()-3, new Date().getDay()+1,0,0)).format('DD/MM/YYYY')
        );

        window.$('#'+this.create_date_to_ref.current.props.id)
        .datepicker({
            endDate: '+0d',
            todayHighlight: true,
        })
        .datepicker(
            'setDate', moment(new Date()).format('DD/MM/YYYY')
        );

        let { serachConditionModel } = this.state;
        await this.props.searchReport(serachConditionModel);

    }

    render() {
        const {serachConditionModel} = this.state;
        const {unitreviewerAll} = this.props

        return (
            <div className="tor tor-template-list">
                <SecureGateRoute/>
                <div id="main-content">
                    <div className="page-body">
                        <BreadCrumb breadcrumb={[
                            {name:'RRS Home',url:AppSettings.defaultUrl},
                            {name:'รายงาน Outstanding Days',url:''}
                        ]}></BreadCrumb>

                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">รายงาน Outstanding Days</h1>
                            </div>
                        </div>

                        <div className="sp-page-result-container">

                        <div className="row">
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_delivery_note" className="rrs-label mb-0">PO /Contract No.</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                        <Input
                                            type="text"
                                            id="PO_CONTRACT_NO"
                                            name="PO_CONTRACT_NO"
                                            className="form-control"
                                            placeholder=""
                                            maxLength="10"
                                            value={serachConditionModel.PO_CONTRACT_NO}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                <label htmlFor="gr_post_date" className="rrs-label mb-0">หน่วยงานเจ้าของเรื่อง /Requistioner</label>
                            </div>
                                <div className="rrs-detail-data">
                                <div className="form-group">
                                    <input
                                        type="text"
                                        id="REQUISITIONER"
                                        name="REQUISITIONER"
                                        className="form-control"
                                        maxLength="8"
                                        floatingPoint={0}
                                        placeholder=""
                                        value={serachConditionModel.REQUISITIONER}
                                        onChange={this.handleInputChange}
                                    />
                                </div>
                            </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_delivery_note" className="rrs-label mb-0">หน่วยงานจัดหา</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">
                                        {
                                            unitreviewerAll && unitreviewerAll.length>0 ?
                                            (
                                                <DropDownMuti
                                                    loadOptions={this.statusOptions}
                                                    id="UNIT"
                                                    value={this.state.serachConditionModel.UNIT}
                                                    className="form-control"
                                                    placeholder=""
                                                    onChange={this.handleDropdownMutiChange}
                                                    // onChange={this.handleChange('runningNoSelectedOptions')}
                                                    // value={this.state.runningNoSelectedOptions}
                                                    >
                                                </DropDownMuti>
                                            ):(<div></div>)
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_delivery_note" className="rrs-label mb-0">MOM Doc No.</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">

                                        <Input
                                            type="text"
                                            id="MOM_DOC_NO"
                                            name="MOM_DOC_NO"
                                            className="form-control"
                                            maxLength="13"
                                            value={serachConditionModel.MOM_DOC_NO}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_delivery_note" className="rrs-label mb-0">RRS Doc No.</label>
                                </div>
                                <div className="rrs-detail-data">
                                    <div className="form-group">

                                        <Input
                                            type="text"
                                            id="RRS_DOC_NO"
                                            name="RRS_DOC_NO"
                                            className="form-control"
                                            maxLength="13"
                                            value={serachConditionModel.RRS_DOC_NO}
                                            onChange={this.handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="rrs-detail-data">
                                    <label htmlFor="gr_post_date" className="rrs-label mb-0">Create Date</label>
                                </div>
                                <div className="row">
                                    <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>From: </span></div>
                                    <div className="col-md-5">
                                        <DatePicker
                                            name="CREATE_DATE_FROM"
                                            id="CREATE_DATE_FROM"
                                            placeholder="dd/mm/yyyy"
                                            data-date-format="dd/mm/yyyy"
                                            value={serachConditionModel.CREATE_DATE_FROM}
                                            onChange={this.handleInputChange}
                                            onBlur={this.handleInputChange}
                                            doctype={"*"}
                                            tagid="search.CREATE_DATE_FROM"
                                            readOnly={true}
                                            ref={this.create_date_from_ref}
                                        />
                                    </div>
                                    <div className="col-md-1 text-right"><span style={{ fontSize: '1rem' }}>To: </span></div>
                                    <div className="col-md-5">
                                        <DatePicker
                                            name="CREATE_DATE_TO"
                                            id="CREATE_DATE_TO"
                                            placeholder="dd/mm/yyyy"
                                            data-date-format="dd/mm/yyyy"
                                            value={serachConditionModel.CREATE_DATE_TO}
                                            onChange={this.handleInputChange}
                                            onBlur={this.handleInputChange}
                                            doctype={"*"}
                                            tagid="search.CREATE_DATE_TO"
                                            readOnly={true}
                                            ref={this.create_date_to_ref}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                            <div className="rrs-detail2">
                                <div className="rrs-form-group-search">
                                    <div className="row justify-content-center mx-0">
                                    <div className="col-md-4"/>
                                        <div className="col-md-4">
                                            <a onClick={this.handleSearch} style={{ cursor: 'pointer' }}>
                                                <i className="icon btn-order-search"  />
                                            </a>
                                            <a onClick={this.handleClear} style={{ cursor: 'pointer',marginLeft:10,marginRight:10 }}> 
                                                <i className="icon btn-order-clear"  />
                                            </a>
                                        </div>
                                        <div className="col-md-4" style={{textAlign:"right"}}>
                                            <a onClick={this.handleExport} style={{ cursor: 'pointer' }}>
                                                <i className="icon btn-order-excel"  />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="rrs-detail2">
                                <div className="sp-table-container">
                                    <div className="row no-gutters sp-table-content">
                                        <SearchTablePage
                                            tablesearch={this.props.resultReportOutSearch}
                                            isAdmin={this.state.isAdmin}
                                            {...this.props} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <DetailBotLogModal />
                    </div>
                </div>
            </div >
        )
    }
}

const mapStateToProps = state => {
    const { SearchRedux,DepartmentMapRedux } = state
    return {
        unitreviewerAll : DepartmentMapRedux.unitreviewerAll,
        resultReportOutSearch: SearchRedux.resultReportOutSearch,
        resultExport: SearchRedux.exportReportOutSearch,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAllUnitReviewer: () => dispatch(getAllUnitReviewerAction()),
        searchReport: (serachCondition) => dispatch(searchReportOutstandingAction(serachCondition)),
        exportReport: (serachCondition) => dispatch(exportReportOutstandingAction(serachCondition))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportOutstandingScreen);